module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/byxCRB/tc-custom/9781504079990.jpg?1718046561817",
      "alt": "This image is the cover for the book Mistletoe and Murder, Amelia Adams"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mistletoe and Murder, Amelia Adams\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A Christmas wedding . . . What could go wrong? ")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Amelia Adams has turned the Scottish mansion she inherited into a luxury hotel. As the festive season gets underway, she prepares to host the wedding of a millionaire to his young fiancée."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" But when Amelia gets a mysterious call from a stranger who says he has something to tell her, she is intrigued. And when a string of shocking events unfold, and the bodies start to mount up, Amelia must uncover the truth."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Will there be a wedding under the mistletoe?"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Or will a killer get away with murder?"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “A wonderful read!” —Amazon reviewer, five stars"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “I love the story . . . couldn’t put it down.” —Amazon reviewer, five stars"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" “Lovely book to curl up with by the fire.” —Amazon reviewer, five stars\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Laura Stewart\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Bloodhound Books\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0